import { Box, Flex, SlideFade, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { Column } from "react-table";
import { darkMode, lightMode } from "../lib/models/color-mode-colors";
import { Quote } from "../lib/models/quote.model";
import FormLoadingOverlay from "./common-quote/FormLoadingOverlay";
import EmptyQuotesTable from "./quotes/EmptyQuotesTable";
import QuotesTable from "./quotes/QuotesTable";
import { allTableColumns } from "./quotes/QuotesTableColumns";

export interface QuoteTableContainerProps {
  refetchQuotes: () => void;
  loading: boolean;
  title: string;
  quotes: Quote[];
  children?: any;
  columns?: Array<Column>;
  emptyTableLabel?: string;
  showAddQuoteMenu?: boolean;
}

function QuoteTableContainer({
  refetchQuotes,
  loading,
  title,
  quotes,
  children,
  columns,
  emptyTableLabel,
  showAddQuoteMenu,
}: QuoteTableContainerProps) {
  const bgColor = useColorModeValue(lightMode[100], darkMode[200]);
  return (
    <Box
      position="relative"
      borderRadius="md"
      height="container.sm"
      marginTop={8}
    >
      {children && [children]}
      <Flex>
        <Box
          position="relative"
          padding={8}
          backgroundColor={bgColor}
          borderRadius="md"
          width="full"
        >
          {loading ? (
            <Box position="relative" padding={8} minHeight="750" width="full">
              <FormLoadingOverlay label="Fetching Quotes..." />
            </Box>
          ) : (
            <SlideFade in={!loading} offsetY="10px">
              {quotes.length < 1 ? (
                <EmptyQuotesTable
                  showAddQuoteMenu={showAddQuoteMenu}
                  label={emptyTableLabel}
                />
              ) : (
                <>
                  <QuotesTable
                    columns={
                      columns ??
                      allTableColumns.filter(
                        (column) => column.Header !== "Owned By"
                      )
                    }
                    refetchQuotes={refetchQuotes}
                    loading={loading}
                    quotes={quotes}
                    title={title}
                  />
                </>
              )}
            </SlideFade>
          )}
        </Box>
      </Flex>
    </Box>
  );
}

export default QuoteTableContainer;
